import type { ReactNode } from 'react';
import { TooltipProvider } from './overlay.tsx';
import { Toaster } from './toast.tsx';

/** Uygulama kökünde bir kez: araç ipuçları ve bildirim alanı. */
export function UiProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider>
      {children}
      <Toaster />
    </TooltipProvider>
  );
}
